module.exports = __webpack_public_path__ + "static/img/icon_wuxiao.59b28a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/voiceScene/icon_wuxiao.png
// module id = 92
// module chunks = 0